import { create } from 'zustand';
import { useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';

const query = new URLSearchParams(window.location.search);
const rawKeyword = query.get('keyword') || query.get('keywords') || '';
// 修复URL解码问题：将空格转换回加号
const keyword = rawKeyword ? rawKeyword.replace(/\s+/g, '+') : '';

export const useKeyword = create<{
  keyword: string;
  setKeyword: (v: string) => void;
  syncKeywordFromUrl: (keyword: string) => void;
}>((set) => ({
  keyword,
  setKeyword: (v: string) => {
    set((state) => ({ ...state, keyword: v }));
  },
  syncKeywordFromUrl: (keyword: string) => {
    set((state) => ({ ...state, keyword }));
  },
}));

export const useKeywordSync = () => {
  const [searchParams] = useSearchParams();
  const { syncKeywordFromUrl } = useKeyword();
  
  useEffect(() => {
    const rawKeyword = searchParams.get('keyword') || searchParams.get('keywords') || searchParams.get('keywordAi') || '';
    const keyword = rawKeyword ? rawKeyword.replace(/\s+/g, '+') : '';
    syncKeywordFromUrl(keyword);
  }, [searchParams, syncKeywordFromUrl]);
};
